import React, {useEffect, useState} from 'react';
import MobileDashboard from "./MobileDashboard";
import DesktopDashboard from "./DesktopDashboard";

// Couleurs pour les graphiques (thème cohérent avec identité visuelle)
const Dashboard = () => {
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

    // Gérer le redimensionnement de l'écran
    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (<div>
        {isSmallScreen ? (<MobileDashboard/>) : (<DesktopDashboard/>)}
    </div>);

};

export default Dashboard;
